/**
 * Live SSE transport — SPA architectural convergence plan §6.4.
 *
 * The legacy `zenoh-sse.ts` used the browser `EventSource`, which
 * cannot carry a Bearer token and has no `AbortController` for
 * epoch/sequence-gap recovery. The new implementation is fetch-based
 * and lives in `./fetch-sse`; this file remains as a compatibility
 * re-export so existing screens keep working while they migrate.
 *
 * The legacy types (`SubscriptionKey`, `SubscriptionPattern`,
 * `LiveEventEnvelope`) live in `./ws-types` and are deprecated in
 * favour of the v1 envelope types in `./v1`.
 */
export {
  FetchSseTransport,
  fetchSseTransport,
  type FetchSseHandle,
  type FetchSseListener,
  type FetchSseState,
} from './fetch-sse';

/**
 * Legacy `getRmfLive()` shim — Phase-0 screens call this to get the
 * single live SSE transport. The convergence target replaces this
 * with `fetchSseTransport()`; the shim returns the same instance so
 * callers see no behaviour change until the per-screen refactor
 * lands.
 *
 * @deprecated use `fetchSseTransport()` from `./fetch-sse`.
 */
import { fetchSseTransport } from './fetch-sse';
import type { FetchSseTransport } from './fetch-sse';
export function getRmfLive(): FetchSseTransport {
  return fetchSseTransport();
}

export type { LiveState } from './ws-types';
export type { FetchSseState as LegacyFetchSseState } from './fetch-sse';